import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import BaseSelect from '../../common/BaseSelect/BaseSelect';
import { BASE_SELECT_DEFAULT_ROLE } from '../../common/BaseSelect/BaseSelect.constants';
import { withFormGroup } from '../../common/FormGroup/FormGroup';
import { SELECT_DEFAULT_DISABLED, SELECT_DEFAULT_MODE, SELECT_DEFAULT_PLACEHOLDER, SELECT_DEFAULT_SIZE } from './Select.constants';
// Component.
// -----------------------------------------------------------------------------
const Select = withFormGroup(({ disabled = SELECT_DEFAULT_DISABLED, mode = SELECT_DEFAULT_MODE, name, onChange, options, role = BASE_SELECT_DEFAULT_ROLE, placeholder = SELECT_DEFAULT_PLACEHOLDER, size = SELECT_DEFAULT_SIZE, isClearable = true, isCreatable = false, formatCreateLabel, inputRef, ...rest }) => (_jsx(BaseSelect, { ...(role && { className: role }), disabled: disabled, mode: mode, multi: false, name: name, onChange: (options) => {
        // Even though in typescript we are typing it as an array at runtime
        // react-select as it is a single element that can be selected what it
        // is doing is returning the element so we have to do this trick to
        // make TypeScript happy.
        if (Array.isArray(options)) {
            onChange(options[0]);
        }
        else {
            onChange(options);
        }
    }, options: options, placeholder: placeholder, size: size, ref: inputRef, isClearable: isClearable, isCreatable: isCreatable, formatCreateLabel: formatCreateLabel, ...rest })));
// Component configuration.
// -----------------------------------------------------------------------------
Select.displayName = 'Select';
const SelectWithFormGroup = React.forwardRef((props, ref) => {
    return _jsx(Select, { ...props, inputRef: ref });
});
SelectWithFormGroup.displayName = 'SelectWithFormGroup';
export default SelectWithFormGroup;
//# sourceMappingURL=Select.js.map